export async function shouldShowPwaOfflineFallback(
  production: boolean,
  online: boolean,
  standalone: boolean,
  baseURI: string,
  probe: typeof fetch,
): Promise<boolean> {
  if (!production) {
    return false;
  }
  if (online && !standalone) {
    return false;
  }

  const manifestUrl = new URL('manifest.webmanifest', baseURI);
  manifestUrl.searchParams.set('ngsw-bypass', '1');
  try {
    await probe(manifestUrl, { cache: 'no-store', signal: AbortSignal.timeout(2500) });
    return false;
  } catch (error) {
    // Даже при navigator.onLine === false только ошибка сети подтверждает offline.
    // HTTP-ответ или таймаут не должны блокировать приложение.
    return error instanceof TypeError;
  }
}
